<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t("hardeight.mechanical_title") }}</div>
      <div class="hardware-li">{{ $t("hardeight.mechanical_dimensions") }}</div>
      <div class="hardware-li">
        {{ $t("hardeight.mechanical_conveyor_length") }}
      </div>
      <div class="hardware-title">{{ $t("hardeight.electrical_title") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_power") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_voltage") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_computer") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_computer2") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_computer3") }}</div>
      <div class="hardware-li">{{ $t("hardeight.electrical_computer4") }}</div>
      <div class="hardware-title">{{ $t("hardeight.rfid_title") }}</div>
      <div class="hardware-li">{{ $t("hardeight.rfid_reader") }}</div>
      <div class="hardware-li">{{ $t("hardeight.rfid_antenna") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>